import { useQuery } from "@tanstack/react-query";
import { DepartmentService } from "../../../../../services/vos/business-tickets/department.service";

const useDepartmentTree = () => {
  const query = useQuery({
    queryKey: ["department-tree"],
    queryFn: () =>
      DepartmentService.getDepartmentTree({
        module: "TICKET",
      }),
  });

  return query;
};

export default useDepartmentTree;
